import React from "react";
// Import commonly used icons
import ActivateIcon from "@/assets/icons/archive_action.svg?react";
import AlertIcon from "@/assets/icons/alert2.svg?react";
import ArchiveIcon from "@/assets/icons/archive.svg?react";
import ArrowCoolDownIcon from "@/assets/icons/arrow_cool_down.svg?react";
import ArrowTopLeftIcon from "@/assets/icons/arrow_top_left.svg?react";
import AssignmentTurnedInIcon from "@/assets/icons/assignment_turned_in.svg?react";
import AskVivoIcon from "@/assets/icons/ask_vivo2.svg?react";
import BloodPressureIcon from "@/assets/icons/blood_pressure.svg?react";
import BookIcon from "@/assets/icons/book.svg?react";
import BookmarkAddIcon from "@/assets/icons/bookmark_add.svg?react";
import BookmarkCheckIcon from "@/assets/icons/bookmark_check.svg?react";
import BoxIcon from "@/assets/icons/box.svg?react";
import CalendarMonthIcon from "@/assets/icons/calendar_month.svg?react";
import CardsStackIcon from "@/assets/icons/cards_stack.svg?react";
import CheckIcon from "@/assets/icons/check.svg?react";
import ClinicalNotesIcon from "@/assets/icons/clinical_notes.svg?react";
import ConfigureIcon from "@/assets/icons/configure.svg?react";
import ContentPasteSearchIcon from "@/assets/icons/content_paste_search.svg?react";
import DataIcon from "@/assets/icons/data.svg?react";
import DeleteAlertIcon from "@/assets/icons/delete_alert.svg?react";
import DeleteIcon from "@/assets/icons/delete.svg?react";
import DesignIcon from "@/assets/icons/design.svg?react";
import DownloadIcon from "@/assets/icons/download.svg?react";
import DuplicateIcon from "@/assets/icons/duplicate.svg?react";
import EcgIcon from "@/assets/icons/ecg.svg?react";
import EditIcon from "@/assets/icons/edit_pencil.svg?react";
import ExploreIcon from "@/assets/icons/explore.svg?react";
import FilterIcon from "@/assets/icons/filter.svg?react";
import FlagIcon from "@/assets/icons/flag.svg?react";
import FrameInspectIcon from "@/assets/icons/frame_inspect.svg?react";
import GraphIcon from "@/assets/icons/graph.svg?react";
import GroupedBarplotIcon from "@/assets/icons/groupedBarplot.svg?react";
import HistoryIcon from "@/assets/icons/history.svg?react";
import HomeIcon from "@/assets/icons/home.svg?react";
import InfoIcon from "@/assets/icons/help.svg?react";
import InsightsIcon from "@/assets/icons/insights.svg?react";
import LabResearchIcon from "@/assets/icons/lab_research.svg?react";
import LegendIcon from "@/assets/icons/legend.svg?react";
import LightbulbIcon from "@/assets/icons/lightbulb.svg?react";
import LinkIcon from "@/assets/icons/link.svg?react";
import ListIcon from "@/assets/icons/list.svg?react";
import LockHollowIcon from "@/assets/icons/lock_hollow.svg?react";
import MapSearchIcon from "@/assets/icons/map_search.svg?react";
import MedicationIcon from "@/assets/icons/medication.svg?react";
import MineIcon from "@/assets/icons/MineIcon.svg?react";
import MonitoredIcon from "@/assets/icons/verified_user.svg?react";
import PersonIcon from "@/assets/icons/person.svg?react";
import SharedIcon from "@/assets/icons/SharedIcon2.svg?react";
import PillOffIcon from "@/assets/icons/pill_off.svg?react";
import PlotsMenuIcon from "@/assets/icons/plots_menu.svg?react";
import PrescriptionsIcon from "@/assets/icons/prescriptions.svg?react";
import RadarIcon from "@/assets/icons/radar.svg?react";
import RiskIcon from "@/assets/icons/risk.svg?react";
import SafetyIcon from "@/assets/icons/safety.svg?react";
import ScatterIcon from "@/assets/icons/scatter.svg?react";
import ShieldLockedIcon from "@/assets/icons/shield_locked.svg?react";
import SignatureIcon from "@/assets/icons/signature.svg?react";
import SitesIcon from "@/assets/icons/sites.svg?react";
import SubjectsIcon from "@/assets/icons/subjects.svg?react";
import TableIcon from "@/assets/icons/table.svg?react";
import VirusIcon from "@/assets/icons/virus.svg?react";
import VisibilityOffIcon from "@/assets/icons/visibility_off.svg?react";
import WcIcon from "@/assets/icons/wc.svg?react";
import WorkspacesIcon from "@/assets/icons/workspaces.svg?react";

interface Feature {
  icon?: string;
  title: string;
  description: string;
  href?: string;
  linkLabel?: string;
  iconColor?: string;
  backgroundColor?: string;
}

interface FeatureGridProps {
  features: Feature[];
  columns?: 2 | 3 | 4;
}

const ICON_MAP: Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement>>
> = {
  activate: ActivateIcon,
  alert: AlertIcon,
  archive: ArchiveIcon,
  arrow_cool_down: ArrowCoolDownIcon,
  arrow_top_left: ArrowTopLeftIcon,
  assignment_turned_in: AssignmentTurnedInIcon,
  askvivo2: AskVivoIcon,
  blood_pressure: BloodPressureIcon,
  book: BookIcon,
  bookmark_add: BookmarkAddIcon,
  bookmark_check: BookmarkCheckIcon,
  box: BoxIcon,
  calendar_month: CalendarMonthIcon,
  cards_stack: CardsStackIcon,
  check: CheckIcon,
  clinical_notes: ClinicalNotesIcon,
  configure: ConfigureIcon,
  content_paste_search: ContentPasteSearchIcon,
  data: DataIcon,
  delete: DeleteIcon,
  delete_alert: DeleteAlertIcon,
  design: DesignIcon,
  download: DownloadIcon,
  duplicate: DuplicateIcon,
  ecg: EcgIcon,
  edit_pencil: EditIcon,
  explore: ExploreIcon,
  filter: FilterIcon,
  flag: FlagIcon,
  frame_inspect: FrameInspectIcon,
  graph: GraphIcon,
  groupedBarplot: GroupedBarplotIcon,
  history: HistoryIcon,
  home: HomeIcon,
  info: InfoIcon,
  insights: InsightsIcon,
  lab_research: LabResearchIcon,
  legend: LegendIcon,
  lightbulb: LightbulbIcon,
  link: LinkIcon,
  list: ListIcon,
  lock_hollow: LockHollowIcon,
  map_search: MapSearchIcon,
  measures: DataIcon,
  medication: MedicationIcon,
  mine: MineIcon,
  monitored: MonitoredIcon,
  person: PersonIcon,
  pill_off: PillOffIcon,
  plots_menu: PlotsMenuIcon,
  prescriptions: PrescriptionsIcon,
  radar: RadarIcon,
  risk: RiskIcon,
  safety: SafetyIcon,
  scatter: ScatterIcon,
  shared: SharedIcon,
  shield_locked: ShieldLockedIcon,
  signature: SignatureIcon,
  sites: SitesIcon,
  subjects: SubjectsIcon,
  table: TableIcon,
  virus: VirusIcon,
  visibility_off: VisibilityOffIcon,
  wc: WcIcon,
  workspace: WorkspacesIcon,
  workspaces: WorkspacesIcon,
};

// Icons whose source SVGs don't follow the shared spec (hardcoded fill and/or
// edge-to-edge artwork) and so render off-color or oversized next to the rest.
// We can't edit the shared SVG assets, so normalize them at render time: force
// the fill to inherit currentColor and set a per-icon footprint that matches
// the optical size of the standard ~60%-fill glyphs. Sizes differ because each
// icon's artwork fills a different share of its own viewBox.
const NORMALIZED_ICON_CLASS: Record<string, string> = {
  mine: "h-[30px] w-[30px] [&_path]:fill-current",
  shared: "h-[26px] w-[26px] [&_path]:fill-current",
  list: "h-[32px] w-[32px] [&_path]:fill-current",
};
const STANDARD_ICON_CLASS = "h-full w-full";

export const FeatureGrid: React.FC<FeatureGridProps> = ({
  features,
  columns,
}) => {
  const cls = "featuregrid" + (columns ? ` featuregrid--${columns}` : "");

  return (
    <div className={cls}>
      {features.map((f, i) => {
        const IconComponent = f.icon ? ICON_MAP[f.icon] : null;
        const iconClassName =
          (f.icon && NORMALIZED_ICON_CLASS[f.icon]) || STANDARD_ICON_CLASS;
        const iconEl = (
          <div
            className="feature__icon"
            style={{
              backgroundColor: f.backgroundColor || undefined,
              // SVGs use fill="currentColor", which inherits from `color`.
              // Set it here when explicit; wiki-blocks.css provides the default (#0c98d0).
              ...(f.iconColor ? { color: f.iconColor } : {}),
            }}
          >
            {IconComponent && <IconComponent className={iconClassName} />}
          </div>
        );
        const body = (
          <>
            {iconEl}
            <h4 className="feature__title">{f.title}</h4>
            <p className="feature__desc">{f.description}</p>
            {f.linkLabel && (
              <span className="feature__link">{f.linkLabel}</span>
            )}
          </>
        );
        // Only render as a link when href is explicitly provided —
        // defaulting to "#" in a hash router navigates the user away.
        return f.href ? (
          <a key={i} href={f.href} className="feature">
            {body}
          </a>
        ) : (
          <div key={i} className="feature feature--static">
            {body}
          </div>
        );
      })}
    </div>
  );
};
